import { useEffect } from 'react';
import { withRouter } from 'react-router';

import Cookies from 'js-cookie';

import { useSelector } from 'react-redux';
import { getTourId } from '../../Utility/utility';
import tourPrevAPI from '../../../API/tour.prev.api';

const GUEST_TOURS_IDS_COOKIE = 'getMyDrafts';

const KeepCreatedToursForGuests = (props) => {
  const { authentication = {}, tourFullData = {} } = useSelector(
    (store) => store
  );
  const { isLoggedIn } = authentication;
  const { isEditMode, activeMultiPart = {} } = tourFullData;
  const { id } = activeMultiPart;

  const isCreateTourPage = () => !getTourId(props) && isEditMode;

  useEffect(() => {
    if (!id) return;
    if (!isLoggedIn && isCreateTourPage()) {
      const tourIds = Cookies.get(GUEST_TOURS_IDS_COOKIE);
      if (tourIds) {
        const arrIds = tourIds.split(',');
        const pos = arrIds.indexOf(id);
        if (pos === -1)
          Cookies.set(GUEST_TOURS_IDS_COOKIE, `${tourIds},${id}`, {
            expires: 30,
          });
      } else {
        Cookies.set(GUEST_TOURS_IDS_COOKIE, id, { expires: 30 });
      }
    }
  }, [id]);

  useEffect(() => {
    if (isLoggedIn) {
      const tourIds = Cookies.get(GUEST_TOURS_IDS_COOKIE);
      if (tourIds) {
        tourPrevAPI
          .attachToursToUser(tourIds)
          .then(
            (res) => res.code === 200 && Cookies.remove(GUEST_TOURS_IDS_COOKIE)
          )
          .catch((err) => console.log(err));
      }
    }
  }, [isLoggedIn]);

  return '';
};

export default withRouter(KeepCreatedToursForGuests);
